import { call, put, takeLatest } from 'redux-saga/effects';

import { withConfirmation } from '../../shared/confirmModal/sagas/confirmModal';
import { satisfactionActions } from '../actions/satisfaction';
import * as api from '../api/satisfaction';

const {
  getAvailableSatisfactionLanguagesRequest,
  getAvailableSatisfactionLanguagesRequestSucceeded,
  getAvailableSatisfactionLanguagesRequestFailed,

  cancelSatisfactionRequest,
  cancelSatisfactionRequestSucceeded,
  cancelSatisfactionRequestFailed,
} = satisfactionActions;

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action) {
    let result;
    try {
      result = yield call(apiAction, action.payload);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.error(exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

function genWithConfirmationAndPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action) {
    let result;
    try {
      yield* withConfirmation(
        {
          headline:
            'Are you sure you want to disable CSAT for this conversation?',
          text: 'This will not trigger a CSAT when this conversation will be closed.',
          confirmText: 'Yes, Proceed',
        },
        function* () {
          result = yield call(apiAction, action.payload);
          yield put(resultSucceededAction(result));
        },
        function* () {
          yield put(resultSucceededAction({}));
        },
      );
    } catch (exception) {
      console.error(exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}

export const satisfaction = [
  takeLatest(
    getAvailableSatisfactionLanguagesRequest.toString(),
    genWithPromise(
      api.requestAvailableSatisfactionLanguages,
      getAvailableSatisfactionLanguagesRequestSucceeded,
      getAvailableSatisfactionLanguagesRequestFailed,
    ),
  ),

  takeLatest(
    cancelSatisfactionRequest.toString(),
    genWithConfirmationAndPromise(
      api.cancelSatisfaction,
      cancelSatisfactionRequestSucceeded,
      cancelSatisfactionRequestFailed,
    ),
  ),
];
